import React from "react";
import { useIntl } from "react-intl";
import { Tag } from "antd";

const outsideStyle = {
  background: "#f0f0f0",
  borderColor: "#d9d9d9",
  color: "#595959",
};

export default function ShopStatus({ inShop }) {
  const intl = useIntl();
  if (inShop) {
    return <Tag color="green" style={{ textTransform: "uppercase" }}>{intl.formatMessage({ id: "inShop" })}</Tag>;
  }
  return <Tag style={{ ...outsideStyle, textTransform: "uppercase" }}>{intl.formatMessage({ id: "checkedOut" })}</Tag>;
}
